import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-centotesi20172024',
  templateUrl: './centotesi20172024.component.html',
  styleUrls: ['./centotesi20172024.component.css']
})
export class Centotesi20172024Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
